import React, { useEffect, useContext } from "react"
import styled from "@emotion/styled"
import Slider from "react-slick"
import { Flex, Box } from "@rebass/grid/emotion"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

import Thumbnail from "./thumbnail"

import { ResultsContext } from "../resultscontext/resultscontext"

import { NextArrow, PrevArrow } from "../resultsarrows/resultsarrows"

const ThumbnailsWrapper = styled(Flex)`
  align-items: center;
  margin: 0 auto;
  //gap: 16px;
  justify-content: space-between;

  @media (min-width: 768px) {
    justify-content: center;
  }
`

const SliderWrapper = styled(Box)`
  position: relative;
  width: 100%;
  @media (min-width: ${theme.mediaqueries.small}) {
    width: fit-content;
  }

  .slick-slider {
    display: flex;
    justify-content: center;
    @media (min-width: ${theme.mediaqueries.small}) {
      width: fit-content;
      margin: 0 auto;
    }
  }

  .slick-list {
    width: 60%;
    @media (min-width: ${theme.mediaqueries.small}) {
      width: fit-content;
    }
  }

  .slick-track {
    @media (min-width: ${theme.mediaqueries.small}) {
      display: flex;
      justify-content: center;
      width: fit-content !important;
    }
  }

  .slick-slide {
    @media (min-width: ${theme.mediaqueries.small}) {
      width: auto !important;
    }
    @media (max-width: 767px) {
      transform: translate(100%, 0);
    }
  }

  .slick-next,
  .slick-prev {
    position: static;
    transform: none;
    background: none !important;
    border: 0;
    height: auto;
    padding: 0 !important;
    width: 20%;
    margin: 0 !important;
    display: flex !important;
    justify-content: center;
    align-items: center;
  }

  .slick-prev {
    justify-content: flex-start;
  }

  .slick-next {
    justify-content: flex-end;
  }
`

const ArrowWrapper = styled.div``

const ThumbnailSlider = ({ slides, settings }) => {
  const resultsContext = useContext(ResultsContext)
  const thumbnails = slides.map((slide) => slide.icon)
  const names = slides.map((slide) => slide.name)
  const {
    autoplay,
    setAutoplay,
    autoplaySpeed,
    resultSliderRef,
    setThumbnailSliderRef,
    currentItemIndex,
    goToSlide,
  } = resultsContext

  const sliderSettings = {
    asNavFor: resultSliderRef,
    ref: (slider) => setThumbnailSliderRef(slider),
    speed: 500,
    slidesToScroll: 1,
    swipeToSlide: false,
    adaptiveHeight: false,
    centerMode: false,
    centerPadding: 0,
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: slides?.length,
    nextArrow: (
      <ArrowWrapper>
        <NextArrow onClick={() => setAutoplay(false)} />
      </ArrowWrapper>
    ),
    prevArrow: (
      <ArrowWrapper>
        <PrevArrow onClick={() => setAutoplay(false)} />
      </ArrowWrapper>
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 2.99,
        },
      },
    ],
    ...settings,
  }

  const prevSlide = () => {
    goToSlide(currentItemIndex - 1)
    setAutoplay(false)
  }

  const nextSlide = () => {
    goToSlide(currentItemIndex + 1)
    setAutoplay(false)
  }

  const handleThumnbailClick = (index) => {
    goToSlide(index)
    if (autoplay) {
      setAutoplay(false)
    }
  }

  useEffect(() => {
    if (!autoplay) {
      resultSliderRef?.slickPause()
    }
  }, [autoplay, resultSliderRef])

  return (
    <ThumbnailsWrapper>
      <Box className={`show-md-up pr-8`}>
        <PrevArrow onClick={prevSlide} />
      </Box>
      <SliderWrapper>
        <Slider {...sliderSettings}>
          {thumbnails.map((thumbnail, index) => (
            <Thumbnail
              isActive={currentItemIndex === index}
              thumbnail={thumbnail}
              name={names[index]}
              autoplay={autoplay}
              autoplaySpeed={autoplaySpeed}
              onClick={() => handleThumnbailClick(index)}
              key={`thumbnail-slide-${index}`} // update in case multiple sliders on same page
            />
          ))}
        </Slider>
      </SliderWrapper>
      <Box className={`show-md-up pl-8`}>
        <NextArrow onClick={nextSlide} />
      </Box>
    </ThumbnailsWrapper>
  )
}

export default ThumbnailSlider
